import './src/styles/global.css';
import 'prism-themes/themes/prism-one-dark.css';

export const wrapRootElement = ({ element }) => {
  return element;
};
